import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/tailwind_index.css"
import "./styles/index.scss";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <App />
);

serviceWorkerRegistration.register();
